<template>
  <div class="box">

    <div class="columns">

      <div class="column is-two-thirds">

        <!-- edit post title -->
        <div class="field">
          <label class="label">Post's title</label>
          <div class="control">
            <input type="text" class="input" placeholder="Title" v-model="post.title">
          </div>
        </div>

        <!-- rich text vue-quill-editor plugin -->
        <quill-editor v-model="post.content_text" :options="{ modules: { toolbar: { container: [] } } }" />
        <br>
        <quill-editor v-model="post.content_html" :options="editorOptions" />
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">

      </div>

      <!-- post right sidebar -->
      <div class="column is-one-third">

        <div class="field">
          <label class="label">Status</label>
          <div class="control select">
            <select v-model="post.status" @change="changedStatus">
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">Audio</label>
          <div class="control">
            <audio controls v-if="post.attachments[0].url">
              <source :src="post.attachments[0].url.replace('https://dts.podtrac.com/redirect.m4a/', 'https://')" type="audio/mp4">
              Your browser does not support the audio element.
            </audio>
            <div class="file">
              <label class="file-label">
                <input @change="uploadAudio" class="file-input" type="file" accept=".m4a" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose an audio file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">Featured image</label>
          <div class="control">
            <img :src="post.image">
            <div class="file">
              <label class="file-label">
                <input @change="uploadImage" class="file-input" type="file" accept=".jpg" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

      </div>

    </div>

    <!-- warning notification -->
    <div v-if="notification.message" :class="'notification is-' + notification.type">
      <button class="delete" @click="hideNotifications"></button>{{notification.message}}
    </div>

    <!-- the form buttons -->
    <button v-if="post.state === 'saved'" type="submit" class="button is-success" @click="update(true)">Update and publish</button>
    <button type="submit" class="button is-info" @click="update(false)">Update</button>
    <router-link to="/admin/posts" class="button is-danger">Cancel</router-link>
  </div>
</template>

<script>
import firebase from 'firebase'

import { mediaRef } from '@/firebase_config'
import editorOptions from './editor-options-complete'
import imageLoader from '@/mixins/image-loader'
import notifier from '@/mixins/notifier'

export default {
  name: 'post-edit',
  data () {
    return {
      /* Here we are filtering out the post containing the provided key in the router params
       * we are using Object.assign to copy the post by value not by reference
       * to prevent updating the poste when typing */
      inputData: '',
      post: Object.assign(
        {},
        (this.posts.filter((post) => {
          return (post['.key'] === this.$route.params.key)
        }))[0]
      ),
      editorOptions
    }
  },
  firebase: {
    media: mediaRef
  },
  props: ['posts', 'update-post'],
  mixins: [imageLoader, notifier],
  methods: {
    // call the updatePost method passed through props
    update (publish) {
      if (this.post.title) {
        // if (publish) {
        //  this.post.state = 'published'
        // }
        this.updatePost(this.post)
      } else {
        this.showNotification('warning', 'The title field can not be empty')
      }
    },
    changedStatus (status) {
      // make sure published status has today date
      this.post.date_modified = Date.now()
      this.post.date_published = Date.now()
    },
    uploadAudio (e) {
      console.log(e)
      let file = e.target.files[0]
      var storageRef = firebase.app().storage('gs://neolivros-public').ref('/' + file.name)
      var self = this
      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        // self.post.attachments[0].url = snapshot.downloadURL
        self.post.attachments[0].url = 'https://storage.googleapis.com/neolivros-public/' + snapshot.metadata.fullPath
        self.post.attachments[0].mime_type = snapshot.metadata.contentType
        self.post.attachments[0].size_in_bytes[0] = snapshot.metadata.size

        var au = document.createElement('audio')
        au.src = self.post.attachments[0].url
        au.addEventListener('loadedmetadata', function () {
          // Obtain the duration in seconds of the audio file (with milliseconds as well, a float value)
          self.post.attachments[0].duration_in_seconds = parseInt(au.duration)
          console.log('The duration of the song is of: ' + self.post.attachments[0].duration + ' seconds')
        }, false)

        console.log(self.post.attachments[0].url)
      })
    },
    uploadImage (e) {
      console.log(e)
      let file = e.target.files[0]
      var storageRef = firebase.app().storage('gs://neolivros-public').ref('/' + file.name)
      var self = this
      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        // self.post.attachments[0].url = snapshot.downloadURL
        self.post.image = 'https://storage.googleapis.com/neolivros-public/' + snapshot.metadata.fullPath
        self.post._itunes.image = 'https://storage.googleapis.com/neolivros-public/' + snapshot.metadata.fullPath
        console.log(self.post.image)
      })
    },
    uploadFeaturedImage (e) {
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('images/' + file.name)

      storageRef.put(file).then((snapshot) => {
        this.post.img = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    styleTags () {
      if (this.inputData !== '') {
        this.tagString.push(`${this.inputData.trim()}`)
        this.inputData = ''
      }
    },
    removeTag (index) {
      this.tagString.splice(index, 1)
    }
  },
  mounted: function () {
    console.log('mounted')
    window.scrollTo(0, 0)
  },
  computed: {
    tagString: {
      get: function () {
        return this.post.tags // if no tags present join is undefined
      },
      set: function (newValue) {
        this.post.tags = newValue
      }
    }
  }
}

</script>
<style>
.tagscontainer {
  border: 2px solid #f2f2f2;
  border-radius: 5px;
  padding: 5px;
}
.pointer {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/content/PostEdit.vue